export class ForkLiftJobRequestDTO {
    unitId:number;
    transactionType?:string;
}